var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirplane(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.159 9.375C132.793 10.524 118.776 14.2007 115.099 15.3497C94.1878 21.7839 81.3193 24.5415 52.3652 33.963C45.0117 36.0312 28.9261 40.6271 22.0322 44.3038C22.0322 44.3038 34.2114 50.0487 39.7264 52.1168C46.3905 54.6446 50.7566 57.8617 51.9056 57.8617",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.079 9.60474C138.079 9.60474 137.39 13.5112 136.701 15.8092C131.875 32.3544 124.981 51.887 118.776 70.7302C118.547 71.6493 113.491 90.2627 113.491 90.2627",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.721 90.0331C113.951 90.0331 113.491 90.0331 113.261 90.0331C101.312 83.1392 89.1328 75.556 76.4941 69.5813C73.7366 68.2025 70.5194 67.2834 67.9917 65.6748",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.581 76.865C79.6357 76.865 79.5263 76.865 79.4716 76.865C76.6281 74.331 73.7298 71.5437 70.7223 69.3477C70.0661 68.8409 69.3005 68.5031 68.699 67.9118",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7612 65.2151C71.2082 62.6874 80.6297 54.4147 87.2938 49.1295C97.175 41.5462 114.18 29.1373 123.831 21.3243C127.048 18.7965 130.265 16.2688 133.483 13.7411C134.632 12.8219 135.781 11.9027 136.47 10.7537C134.172 11.4431 128.197 14.4304 124.75 16.4986C114.41 22.2435 90.7407 35.5716 80.3999 41.3164C71.6677 46.3719 58.3396 54.1849 51.4458 58.551",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7998 99.6843C61.0978 96.697 62.4765 90.0329 63.3957 86.1264C64.7745 79.0028 65.6936 70.96 67.0724 66.1343",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6792 58.3214C52.1388 68.6622 53.5176 76.705 56.0453 88.6543C56.7347 91.6417 56.9645 97.1567 58.8028 99.4547",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1799 98.5351C64.546 93.7094 67.3036 90.4923 71.6697 85.6666C75.806 81.3005 78.1039 78.7728 82.9296 73.0279",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4929 66.1744C24.1095 69.9085 3.16754 92.5383 11.1814 110.619C12.1762 112.65 13.4041 114.674 15.0842 116.226C26.1112 125.97 40.646 112.931 43.5827 102.077C43.781 100.926 43.9863 100.003 43.7186 98.8662C43.1899 96.8208 40.8106 95.2897 38.4798 95.3604C36.1491 95.4312 34.0792 96.4101 32.2493 97.6109C26.977 101.047 22.6377 107.313 20.3928 114.158M28.681 141.466C22.0266 138.095 19.0877 131.996 18.7657 125.298",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/Airplane.24c66529c6a2a5346718ed8af4bf187b.svg";
export { ForwardRef as ReactComponent };